import {RailsPartial} from '@github-ui/rails-partial'
import {pullRequestsChecksRoute} from './checks-route'
import styles from './Checks.module.css'

export function ChecksEntrypoint() {
  return (
    <div className={styles.checksRoot}>
      <RailsPartial partialName="Main" route={pullRequestsChecksRoute} />
    </div>
  )
}
